// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetUsersRequestModel from '../../model/get-users-request-model';
import GetUsersRequestDTO from '../dto/get-users-request-dto';
import dtoSchema from '../schemas/get-users-request-schema';

export default abstract class GetUsersRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetUsersRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.searchCriteria = data.searchCriteria;
      this.statusId = data.statusId;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  searchCriteria?: string;
  /**
  * @type {int32}
  */
  statusId?: number;

  static toModel(dto: DeepPartial<GetUsersRequestDTO>): GetUsersRequestModel;
  static toModel(dto: DeepPartial<GetUsersRequestDTO> | undefined | null): GetUsersRequestModel | undefined;
  static toModel(dto: DeepPartial<GetUsersRequestDTO> | undefined | null): GetUsersRequestModel | undefined {
    return dto ? new GetUsersRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetUsersRequestModel> | GetUsersRequestModel): GetUsersRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      searchCriteria: unwrapped.searchCriteria,
      statusId: unwrapped.statusId,
    } as GetUsersRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetUsersRequestModel, can not map to GetUsersRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
